export const currency = (num: any) => {
  return parseFloat(num)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

export const removeDecimalInCurrency = (num: any) => {
  return parseFloat(num)
    .toFixed(0)
    .replace(/\d(?=(\d{3})+$)/g, "$&,");
};